export { default } from './ChattelPropertyExpenses';
